import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { verifyEmail } from '../api/apiServices';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const confirmEmail = async () => {
      if (token) {
        try {
          const response = await verifyEmail(token);
          setMessage(response.message);
          setTimeout(() => navigate('/login'), 3000);
        } catch (error) {
          setMessage('Email verification failed. The link may have expired.');
        }
      }
    };

    confirmEmail();
  }, [token, navigate]);

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded-lg text-center">
      <h2 className="text-2xl font-bold mb-4">Email Verification</h2>
      <p>{message || 'Verifying email, please wait...'}</p>
    </div>
  );
};

export default VerifyEmail;
